import React, { useEffect, useContext, useState } from 'react';
import slugify from 'slugify';

const SwatchProducts = ({ items, selectedProduct, handleChange }) => {

  return (
    <div className='cross-sell__swatch-options'>
      {items.map(p => (
        <label className={`swatch-element ${!p.available ? 'unavailable' : ''}`}>
          <span className="u-hidden">{p.title.split('-')[0]}</span>
          <input type="radio" name="product" key={p.handle} value={p.handle} defaultChecked={p.id == selectedProduct.id ? true : false} onChange={handleChange}></input>
          <figure>
            <img src={window.__webpack_public_path__ + slugify(p.title.replace(/[.+&™/]/g, ' '), { lower: true }) + '.png'} loading="lazy" alt={p.title} />
          </figure>
        </label>
      ))}
    </div>
  )
}

export default SwatchProducts